import React, { useState, useEffect } from 'react';
import { Button, Grid, Icon } from '../../../shared';
import './customer-documents.scss';
import { services } from '../../../../shared/api/services';
import saveAs from 'file-saver';
export var CustomerDocumentsTable = function (_a) {
    var deleteDocumentFunction = _a.deleteDocumentFunction, applicant = _a.applicant, fetchData = _a.fetchData, index = _a.index, documentList = _a.documentList, showModal = _a.showModal, modalVisible = _a.modalVisible, refresh = _a.refresh;
    var _b = useState([]), displayData = _b[0], setDisplayData = _b[1];
    var _c = useState(0), forceUpdateCount = _c[0], setForceUpdateCount = _c[1];
    var forceUpdate = function () { return setForceUpdateCount(function (forceUpdateCount) { return forceUpdateCount + 1; }); };
    var deleteDocument = function (e) {
        deleteDocumentFunction(e).then(function () {
            forceUpdate();
        });
    };
    var getCustomerDocument = function (documentId, description, mimeType) {
        services.getCustomerDocument(documentId).then(function (blob) {
            saveAs(blob, "".concat(description, ".").concat(mimeType === null || mimeType === void 0 ? void 0 : mimeType.split('/')[1]));
        });
    };
    var columns = [
        {
            id: 'docType',
            description: 'Category',
        },
        {
            id: 'description',
            description: 'Document Name',
        },
        {
            id: 'id',
            description: 'Delete',
            sort: false,
            render: function (column, row) {
                return (React.createElement("button", { type: "button", onClick: deleteDocument, "data-value": row.id },
                    React.createElement(Icon, { name: "close" }),
                    React.createElement("span", { className: "u-hidden-visually" }, "Remove document")));
            },
        },
        {
            id: 'view',
            description: '',
            sort: false,
            render: function (column, row) {
                return (React.createElement(Button, { type: "button", variant: "secondary", onClick: function () { return getCustomerDocument(row.id, row.description, row.mimeType); } }, "View"));
            },
        },
    ];
    useEffect(function () {
        fetchData && !!(applicant === null || applicant === void 0 ? void 0 : applicant.customerId)
            ? fetchData(applicant === null || applicant === void 0 ? void 0 : applicant.customerId)
                .then(function (result) {
                setDisplayData(result);
            })
                .catch(function () {
                setDisplayData([]);
            })
            : setDisplayData(documentList);
    }, [forceUpdateCount, refresh]);
    return (React.createElement("div", null,
        React.createElement("span", { className: "c-customer-document-label" }, applicant === null || applicant === void 0 ? void 0 :
            applicant.firstName,
            " ", applicant === null || applicant === void 0 ? void 0 :
            applicant.surname,
            " :",
            ' ',
            (applicant === null || applicant === void 0 ? void 0 : applicant.isMainApplicant) ? 'Main Applicant' : 'Applicant ' + (index + 1)),
        React.createElement("div", { className: "c-customer-grid" },
            React.createElement(Grid, { pinned: 'right', rowData: displayData, columns: columns, noRowsMessage: "No existing client documents" })),
        !(modalVisible !== null && modalVisible !== void 0 ? modalVisible : false) && (React.createElement(Button, { type: "button", variant: "secondary", size: "small", dataValue: applicant === null || applicant === void 0 ? void 0 : applicant.customerId, onClick: showModal }, "Upload File"))));
};
